export default {"src":"/_next/static/media/bike_40.09405495.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};